export default "__VITE_ASSET__$OWoshF___"